import { getItem, removeItem } from '../helpers/webStorage';
import { GlobalMessage, Action, StorageStateKey } from '../types';

export enum GlobalMessagesActionTypes {
  ADD_GLOBAL_MESSAGE = 'ADD_GLOBAL_MESSAGE',
  REMOVE_GLOBAL_MESSAGE = 'REMOVE_GLOBAL_MESSAGE'
}

const globalMessagesEl = document.getElementById('globalMessagesContent');
const initialGlobalMessages: GlobalMessage[] =
  getItem(StorageStateKey.GLOBAL_MESSAGES) || (globalMessagesEl && JSON.parse(globalMessagesEl.innerHTML)) || [];

if (getItem(StorageStateKey.GLOBAL_MESSAGES)) {
  removeItem(StorageStateKey.GLOBAL_MESSAGES);
}

function globalMessagesReducer(
  prevState: GlobalMessage[] = initialGlobalMessages,
  action: Action<GlobalMessagesActionTypes>
): GlobalMessage[] {
  switch (action.type) {
    case GlobalMessagesActionTypes.REMOVE_GLOBAL_MESSAGE: {
      return prevState.filter((globalMessage) => globalMessage.message !== action.globalMessage.message);
    }
    case GlobalMessagesActionTypes.ADD_GLOBAL_MESSAGE: {
      return prevState.find((globalMessage) => globalMessage.message === action.globalMessage.message)
        ? prevState
        : prevState.concat([action.globalMessage]);
    }
    default: {
      return prevState;
    }
  }
}

export default globalMessagesReducer;
